import { TFunction } from 'i18next';

import { ALL, ALL_WORD } from 'global/constants';
import { DropdownListItem } from 'webclient.constants';
import {
  formatYearsToSingleValues,
  getYearLabel,
} from 'approot/shared/logic/years';
import { InquisitiveYears } from 'global/graphql/scalars.type';

export function getSelectedOptions(
  selected?: string[],
  allOption?: DropdownListItem
) {
  return !allOption || (selected && selected.length)
    ? selected
    : [allOption.value];
}

export function formatDropdownLabel({
  options,
  selected,
  label,
  labelUnselected = `Choose a ${label}`,
  allOptionItem,
  t,
}: {
  options: DropdownListItem[];
  selected: string[] | undefined;
  label: string;
  labelUnselected?: string;
  allOptionItem?: DropdownListItem | undefined;
  t?: TFunction;
}) {
  const selectedOptions = options.filter(option =>
    selected?.find(s => s === option.value)
  );

  if (
    !selected ||
    selected?.length === 0 ||
    selected.includes(ALL) ||
    selected.includes(ALL_WORD) ||
    !selected.some(s => options.find(o => o.value === s))
  ) {
    return labelUnselected;
  } else if (selectedOptions.length === 1) {
    return selectedOptions[0].label;
  } else if (selected.length === options.length - 1 && allOptionItem) {
    return allOptionItem.label;
  }

  if (t && label === getYearLabel(t)) {
    return `${formatYearsToSingleValues(
      selectedOptions.map(s => s.value) as InquisitiveYears[],
      t
    )}`;
  } else {
    return `${selectedOptions.map(s => s.labelShort || s.label).join(', ')}`;
  }
}
